var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Icon, Modal, Row, Tag, Typography, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { NotificationUtils } from "../../utilities";
var defaultSupportedFileTypes = [
    "video/*",
    "image/*",
    ".doc",
    ".docx",
    "text/csv",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ".zip",
    "application/pdf"
];
var UploadFileView = function (_a) {
    var visible = _a.visible, onCancel = _a.onCancel, _b = _a.maxCount, maxCount = _b === void 0 ? 1 : _b, _c = _a.maxSize, maxSize = _c === void 0 ? 5 : _c, name = _a.name, onSubmit = _a.onSubmit, helpText = _a.helpText, _d = _a.mode, mode = _d === void 0 ? "default" : _d, _e = _a.supportedFileTypes, supportedFileTypes = _e === void 0 ? defaultSupportedFileTypes : _e, supportedExtensions = _a.supportedExtensions, _f = _a.uploadText, uploadText = _f === void 0 ? "Upload" : _f, _g = _a.header, header = _g === void 0 ? "Upload files" : _g, footer = _a.footer, onChange = _a.onChange, uploadPreview = _a.uploadPreview, postUploadView = _a.postUploadView, shouldReset = _a.shouldReset, didReset = _a.didReset, _h = _a.loading, loading = _h === void 0 ? false : _h, fileList = _a.fileList;
    if (!helpText) {
        helpText =
            React.createElement(React.Fragment, null,
                "Upload requirements:",
                React.createElement("ul", null,
                    React.createElement("li", { style: { listStyleType: "disc", lineHeight: "18px" } },
                        "You can upload up to ",
                        maxCount,
                        " attachment(s), ",
                        maxSize,
                        "MB each."),
                    supportedExtensions ?
                        React.createElement("li", { style: { listStyleType: "disc", lineHeight: "18px" } },
                            "Only files with the following extensions are allowed: ", supportedExtensions === null || supportedExtensions === void 0 ? void 0 :
                            supportedExtensions.join(", ")) :
                        " "));
    }
    var _j = useState([]), files = _j[0], setFiles = _j[1];
    useEffect(function () {
        if (shouldReset) {
            setFiles([]);
            didReset && didReset();
        }
    }, [shouldReset, didReset]);
    var handleFileRemoval = function (fileItem) {
        var newFileList = files.filter(function (file) { return file.uid !== fileItem.uid; });
        setFiles(newFileList);
        onChange && onChange(newFileList);
    };
    useEffect(function () {
        if (fileList) {
            setFiles(fileList);
            onChange && onChange(fileList);
        }
    }, [fileList]);
    useEffect(function () {
        if (!fileList) {
            setFiles([]);
            onChange && onChange(fileList || []);
        }
    }, [visible]);
    return (React.createElement(Modal, { style: {}, bodyStyle: { minHeight: "300px" }, footer: false, visible: visible, onCancel: function () { setFiles([]); onChange && onChange(fileList || []); onCancel(); }, width: mode === "default" ? undefined : "560px", destroyOnClose: true, closeIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faTimes }); } }), className: "no-padding-modal" },
        React.createElement("div", { className: "padding-lg" },
            header &&
                React.createElement("div", { className: "padding-sm-vertical strong font-size-xxl" }, header),
            !uploadPreview &&
                React.createElement("div", { className: "margin-bottom-xs" },
                    files.map(function (fileItem, indx) {
                        return React.createElement(Tag, { key: indx, visible: true, closable: true, onClose: function () { return handleFileRemoval(fileItem); }, id: fileItem.uid }, fileItem.name);
                    }),
                    postUploadView && postUploadView),
            uploadPreview ?
                uploadPreview :
                (files.length === 0 || maxCount > 1) && !postUploadView &&
                    React.createElement(React.Fragment, null,
                        React.createElement(Upload.Dragger, { fileList: files, beforeUpload: function () { return false; }, name: name, multiple: maxCount && maxCount > 1 ? true : false, className: "background-white", showUploadList: false, onChange: function (info) {
                                if (info.file.status !== "uploading") {
                                    var file = info.file, fileList_1 = info.fileList;
                                    if (file.uid === fileList_1[fileList_1.length - 1].uid) {
                                        if (fileList_1.length <= maxCount) {
                                            var newFileList_1 = [];
                                            fileList_1.forEach(function (file) {
                                                var fullFileName = file.name;
                                                var fileExtension = fullFileName.substring(fullFileName.lastIndexOf(".") + 1, fullFileName.length);
                                                var fileNameWithoutExtension = fullFileName.substring(0, fullFileName.lastIndexOf("."));
                                                var ext = file.name.split('.');
                                                if ((ext && ext.length === 2) && (maxSize ? file.size < maxSize * 1024 * 1024 : true) && file.size > 0 && (supportedExtensions ? supportedExtensions.includes(fileExtension.toLowerCase()) : true)) {
                                                    var newFileName_1 = fullFileName;
                                                    var index = 0;
                                                    do {
                                                        if (index > 0) {
                                                            newFileName_1 = "".concat(fileNameWithoutExtension, " (").concat(index, ").").concat(fileExtension);
                                                        }
                                                        index++;
                                                    } while (newFileList_1.find(function (file) { return file.name === newFileName_1; }));
                                                    if (file.originFileObj) {
                                                        var fileBlob = file.originFileObj.slice(0, file.size, file.type);
                                                        var newFile = new File([fileBlob], newFileName_1, { type: file.type });
                                                        newFileList_1.push(__assign(__assign({}, file), { name: newFileName_1, originFileObj: newFile }));
                                                    }
                                                }
                                                else {
                                                    NotificationUtils.warning("Upload Failed!", helpText);
                                                }
                                            });
                                            setFiles(newFileList_1);
                                            onChange && onChange(newFileList_1);
                                        }
                                        else {
                                            NotificationUtils.warning("Max limit reached", helpText);
                                        }
                                    }
                                }
                            } },
                            React.createElement(Row, { type: "flex", justify: "center", align: "middle", style: { height: "120px" } },
                                React.createElement(Col, null,
                                    "Drag and drop or ",
                                    React.createElement(Button, { type: "link", className: "no-padding no-margin" }, "browse")))),
                        helpText &&
                            React.createElement(React.Fragment, null,
                                React.createElement("br", null),
                                React.createElement(Typography.Paragraph, { type: "secondary", style: { fontSize: "12px", paddingTop: "4px", fontWeight: "bold", marginTop: "-18px" } }, helpText))),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("div", { className: "align-right" },
                React.createElement(Button, { loading: loading, disabled: loading || (files === null || files === void 0 ? void 0 : files.length) === 0, type: "primary", onClick: function () { return onSubmit(files); }, style: { position: "absolute", right: "32px", bottom: "32px" } }, uploadText)),
            footer &&
                React.createElement("div", { className: "padding-sm-vertical" }, footer))));
};
export default UploadFileView;
//# sourceMappingURL=index.js.map